{
  "pt": {
    "announcement": {
      "actions": {
        "delete_announcement": "Eliminar publicação de notícias",
        "edit": "Editar",
        "new": "Publicação de notícias",
        "pin": "Fixar no topo",
        "save": "Guardar",
        "submit": "Correio",
        "unpin": "Retirar os pinos do topo"
      },
      "attributes": {
        "description": "Descrição"
      },
      "labels": {
        "allUnits": "todas as unidades",
        "customers": "clientes",
        "for": "para",
        "image_tab": "Imagem",
        "notSeenYet": "Ainda não visto",
        "now": "Agora",
        "pinned": "Este anúncio é mostrado no topo da página do cliente.",
        "pinnedBadge": "Fixado",
        "seen": "Visto",
        "seenByCount": "Visto por {count} de {total}",
        "sharedWithPrefix": "Partilhado com",
        "sharedWithProject": "Partilhado com {units} de {project}",
        "someUnits": "algumas unidades",
        "start": "Início",
        "unitsCount": "1 Unidade | {count} Unidades",
        "video_tab": "Vídeo",
        "youtube_video": "URL do vídeo do YouTube"
      },
      "name": "Anúncio",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Em breve, encontrará actualizações regulares sobre o local de construção no seu painel de instrumentos.",
            "title": "Receba as suas notícias aqui!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Dê as boas-vindas aos seus clientes ou partilhe uma atualização sobre o projeto.",
            "title": "Criar a sua primeira publicação de notícias"
          },
          "none": {
            "project_required": "Selecionar um projeto",
            "selectProject": "Selecione um projeto e comece a criar!",
            "subtitle": "Dê as boas-vindas aos seus clientes ou partilhe uma atualização sobre qualquer projeto."
          },
          "paste_video_url": "Cole aqui a sua hiperligação para o YouTube"
        }
      },
      "toasts": {
        "create": "Publicação de notícias",
        "delete": "Notícia suprimida",
        "invalid_video": "Este não é um vídeo válido do YouTube",
        "update": "A notícia foi actualizada"
      },
      "validation": {
        "pleaseAddContent": "Adicionar uma imagem, um vídeo ou uma descrição"
      }
    }
  }
}
